"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extensionFromUrl = exports.tiktokPostProgressLabel = exports.isTikTokAuthError = exports.TIKTOK_IN_PROGRESS_PUBLISH_STATUSES = exports.tiktokPhotoTitleFromCaption = exports.validateTikTokMedia = exports.TIKTOK_ASPECT_TOLERANCE = exports.TIKTOK_PREFERRED_ASPECT = exports.tiktokPublishBlockReason = exports.tiktokCommercialLabelPrompt = exports.tiktokConsentText = exports.TIKTOK_BRANDED_PRIVATE_TOOLTIP = exports.TIKTOK_DISCLOSURE_REQUIRED_TOOLTIP = exports.TIKTOK_BRANDED_CONTENT_AND_MUSIC_CONFIRMATION = exports.TIKTOK_MUSIC_USAGE_CONFIRMATION = exports.tiktokPrivacyLabel = exports.defaultTikTokPrivacyLevel = exports.TIKTOK_PRIVACY_LABELS = exports.TIKTOK_PRIVACY_LEVELS = exports.TIKTOK_PHOTO_TITLE_MAX = exports.TIKTOK_MAX_PHOTOS = exports.TIKTOK_MAX_VIDEO_BYTES = exports.TIKTOK_MAX_PHOTO_EDGE = exports.TIKTOK_MAX_PHOTO_BYTES = exports.TIKTOK_PHOTO_EXTENSIONS = exports.TIKTOK_NATIVE_PHOTO_EXTENSIONS = exports.TIKTOK_VIDEO_EXTENSIONS = void 0;
const HttpInterface_1 = require("./HttpInterface");
/** TikTok Content Posting API video limits (PULL_FROM_URL / direct post). */
exports.TIKTOK_VIDEO_EXTENSIONS = ["mp4", "webm", "mov"];
/** Formats TikTok accepts natively for photo posts (PNG must be converted). */
exports.TIKTOK_NATIVE_PHOTO_EXTENSIONS = ["jpg", "jpeg", "webp"];
/** Formats accepted in the media library; PNG is auto-converted on publish. */
exports.TIKTOK_PHOTO_EXTENSIONS = ["jpg", "jpeg", "webp", "png"];
exports.TIKTOK_MAX_PHOTO_BYTES = 20 * 1024 * 1024; // 20 MB per image
exports.TIKTOK_MAX_PHOTO_EDGE = 1080; // max 1080p
exports.TIKTOK_MAX_VIDEO_BYTES = 10 * 1024 * 1024 * 1024; // 10 GB
exports.TIKTOK_MAX_PHOTOS = 35;
exports.TIKTOK_PHOTO_TITLE_MAX = 90;
/** TikTok Content Posting API privacy_level values. */
exports.TIKTOK_PRIVACY_LEVELS = [
    "PUBLIC_TO_EVERYONE",
    "FOLLOWER_OF_CREATOR",
    "MUTUAL_FOLLOW_FRIENDS",
    "SELF_ONLY",
];
exports.TIKTOK_PRIVACY_LABELS = {
    PUBLIC_TO_EVERYONE: "Everyone",
    FOLLOWER_OF_CREATOR: "Followers",
    MUTUAL_FOLLOW_FRIENDS: "Friends",
    SELF_ONLY: "Only me",
};
/**
 * Fallback when a privacy level must be sent but the user never chose one
 * (e.g. legacy posts). UX must not pre-select this — Content Sharing Guidelines
 * require a manual privacy choice with no default.
 */
const defaultTikTokPrivacyLevel = (options) => {
    for (const level of exports.TIKTOK_PRIVACY_LEVELS) {
        if (options.includes(level)) {
            return level;
        }
    }
    return options[0];
};
exports.defaultTikTokPrivacyLevel = defaultTikTokPrivacyLevel;
const tiktokPrivacyLabel = (level) => { var _a; return (_a = exports.TIKTOK_PRIVACY_LABELS[level]) !== null && _a !== void 0 ? _a : level; };
exports.tiktokPrivacyLabel = tiktokPrivacyLabel;
exports.TIKTOK_MUSIC_USAGE_CONFIRMATION = "By posting, you agree to TikTok's Music Usage Confirmation";
exports.TIKTOK_BRANDED_CONTENT_AND_MUSIC_CONFIRMATION = "By posting, you agree to TikTok's Branded Content Policy and Music Usage Confirmation.";
exports.TIKTOK_DISCLOSURE_REQUIRED_TOOLTIP = "You need to indicate if your content promotes yourself, a third party, or both.";
exports.TIKTOK_BRANDED_PRIVATE_TOOLTIP = "Branded content visibility cannot be set to private.";
/** Consent copy required above the publish control (guidelines §2 / §4). */
const tiktokConsentText = (settings) => {
    if (settings.commercialDisclosure && settings.brandedContent) {
        return exports.TIKTOK_BRANDED_CONTENT_AND_MUSIC_CONFIRMATION;
    }
    return `${exports.TIKTOK_MUSIC_USAGE_CONFIRMATION}.`;
};
exports.tiktokConsentText = tiktokConsentText;
/** Audience label prompt when commercial disclosure options are selected. */
const tiktokCommercialLabelPrompt = (settings, isPhoto) => {
    if (!settings.commercialDisclosure) {
        return undefined;
    }
    const media = isPhoto ? "photo" : "video";
    if (settings.brandedContent) {
        return `Your ${media} will be labeled as 'Paid partnership'`;
    }
    if (settings.brandOrganic) {
        return `Your ${media} will be labeled as 'Promotional content'`;
    }
    return undefined;
};
exports.tiktokCommercialLabelPrompt = tiktokCommercialLabelPrompt;
/**
 * Client-side gate for Schedule / Publish Now when TikTok is selected.
 * Returns a user-facing reason, or undefined when publishing is allowed.
 */
const tiktokPublishBlockReason = (settings, privacyOptions) => {
    if (!settings.privacyLevel ||
        !privacyOptions.includes(settings.privacyLevel)) {
        return "Select a TikTok privacy setting before publishing.";
    }
    if (settings.commercialDisclosure &&
        !settings.brandOrganic &&
        !settings.brandedContent) {
        return exports.TIKTOK_DISCLOSURE_REQUIRED_TOOLTIP;
    }
    if (settings.brandedContent && settings.privacyLevel === "SELF_ONLY") {
        return exports.TIKTOK_BRANDED_PRIVATE_TOOLTIP;
    }
    return undefined;
};
exports.tiktokPublishBlockReason = tiktokPublishBlockReason;
/** Preferred vertical aspect ratio for feed (9:16). Soft check only. */
exports.TIKTOK_PREFERRED_ASPECT = 9 / 16;
exports.TIKTOK_ASPECT_TOLERANCE = 0.08;
const normalizeExt = (extension) => (extension !== null && extension !== void 0 ? extension : "").toLowerCase().replace(/^\./, "");
const isVideoType = (file) => {
    const ext = normalizeExt(file.extension);
    if (file.type === HttpInterface_1.ContentType.VIDEO) {
        return true;
    }
    return exports.TIKTOK_VIDEO_EXTENSIONS.includes(ext);
};
const isImageType = (file) => {
    const ext = normalizeExt(file.extension);
    if (file.type === HttpInterface_1.ContentType.IMAGE) {
        return true;
    }
    return exports.TIKTOK_PHOTO_EXTENSIONS.includes(ext);
};
/**
 * Hard validation for TikTok media before schedule/publish.
 * Returns blocking errors (empty = valid enough to attempt publish).
 */
const validateTikTokMedia = (files) => {
    const errors = [];
    const warnings = [];
    if (files.length === 0) {
        errors.push("TikTok requires at least one video or photo.");
        return { valid: false, errors, warnings };
    }
    const videos = files.filter(isVideoType);
    const images = files.filter(isImageType);
    const unknown = files.filter((f) => !isVideoType(f) && !isImageType(f));
    if (unknown.length > 0) {
        const names = unknown
            .map((f) => f.filename || normalizeExt(f.extension) || "file")
            .join(", ");
        errors.push(`Unsupported TikTok media format (${names}). Use MP4/WebM/MOV for video or JPG/JPEG/WEBP/PNG for photos.`);
    }
    if (videos.length > 0 && images.length > 0) {
        errors.push("TikTok cannot mix video and photos in one post. Use a single video or a photo carousel.");
    }
    if (videos.length > 1) {
        errors.push("TikTok allows only one video per post.");
    }
    if (images.length > exports.TIKTOK_MAX_PHOTOS) {
        errors.push(`TikTok photo carousels support at most ${exports.TIKTOK_MAX_PHOTOS} images.`);
    }
    for (const video of videos) {
        const ext = normalizeExt(video.extension);
        if (ext &&
            !exports.TIKTOK_VIDEO_EXTENSIONS.includes(ext)) {
            errors.push(`TikTok video must be MP4, WebM, or MOV (got .${ext}).`);
        }
        if (video.size != null && video.size > exports.TIKTOK_MAX_VIDEO_BYTES) {
            errors.push("TikTok video must be 10 GB or smaller.");
        }
        if (video.width != null &&
            video.height != null &&
            video.width > 0 &&
            video.height > 0) {
            const ratio = video.width / video.height;
            if (Math.abs(ratio - exports.TIKTOK_PREFERRED_ASPECT) > exports.TIKTOK_ASPECT_TOLERANCE) {
                warnings.push("TikTok performs best with 9:16 vertical video. Other ratios may letterbox.");
            }
        }
    }
    for (const image of images) {
        const ext = normalizeExt(image.extension);
        if (ext &&
            !exports.TIKTOK_PHOTO_EXTENSIONS.includes(ext)) {
            errors.push(`TikTok photos must be JPG, JPEG, WEBP, or PNG (got .${ext}).`);
        }
        if (ext === "png") {
            warnings.push("PNG photos will be auto-converted to JPEG for TikTok.");
        }
        if (image.size != null && image.size > exports.TIKTOK_MAX_PHOTO_BYTES) {
            warnings.push("Large photos will be resized/compressed to meet TikTok's 20MB / 1080p limits.");
        }
    }
    return { valid: errors.length === 0, errors, warnings };
};
exports.validateTikTokMedia = validateTikTokMedia;
const tiktokPhotoTitleFromCaption = (caption) => {
    const trimmed = caption.trim();
    if (trimmed.length <= exports.TIKTOK_PHOTO_TITLE_MAX) {
        return trimmed;
    }
    return `${trimmed.slice(0, exports.TIKTOK_PHOTO_TITLE_MAX - 1)}…`;
};
exports.tiktokPhotoTitleFromCaption = tiktokPhotoTitleFromCaption;
/** TikTok publish statuses that indicate content is still being processed. */
exports.TIKTOK_IN_PROGRESS_PUBLISH_STATUSES = [
    "PROCESSING_UPLOAD",
    "PROCESSING_DOWNLOAD",
    "SEND_TO_USER_INBOX",
];
/** Detect OAuth/token errors that require the user to reconnect TikTok. */
const isTikTokAuthError = (message) => /access_token|refresh_token|token.*invalid|token.*expired|unauthorized|401|revoked|access_denied|invalid_grant/i.test(message);
exports.isTikTokAuthError = isTikTokAuthError;
/** User-facing label for a TikTok post that is scheduled or in progress. */
const tiktokPostProgressLabel = (publishStatus, fallback) => {
    switch (publishStatus) {
        case "PROCESSING_UPLOAD":
            return "Uploading to TikTok…";
        case "PROCESSING_DOWNLOAD":
            return "Pending moderation";
        case "SEND_TO_USER_INBOX":
            return "Waiting in TikTok inbox — open TikTok to finish this post.";
        default:
            return fallback !== null && fallback !== void 0 ? fallback : "Publishing…";
    }
};
exports.tiktokPostProgressLabel = tiktokPostProgressLabel;
const extensionFromUrl = (url) => {
    var _a, _b;
    try {
        const pathname = new URL(url).pathname;
        const match = pathname.match(/\.([a-zA-Z0-9]+)(?:$|\?)/);
        return (_a = match === null || match === void 0 ? void 0 : match[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    }
    catch (_c) {
        const match = url.match(/\.([a-zA-Z0-9]+)(?:$|\?)/);
        return (_b = match === null || match === void 0 ? void 0 : match[1]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    }
};
exports.extensionFromUrl = extensionFromUrl;
